module.exports = __webpack_public_path__ + "static/media/fuxing_bg.2faec3c4.png";